import { render, staticRenderFns } from "./ProgramPersonalizations.vue?vue&type=template&id=83a050a2&scoped=true&"
import script from "./ProgramPersonalizations.vue?vue&type=script&lang=js&"
export * from "./ProgramPersonalizations.vue?vue&type=script&lang=js&"
import style0 from "./ProgramPersonalizations.vue?vue&type=style&index=0&id=83a050a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a050a2",
  null
  
)

export default component.exports